// MobilePinDemo.tsx - Full-screen mobile pin art demo page
import React from 'react';
import styled from 'styled-components';
import MobilePinArt from '../components/PretextChart/MobilePinArt';

const PageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0a0f;
  overflow: hidden;
  
  /* Prevent pull-to-refresh and overscroll */
  overscroll-behavior: none;
  touch-action: none;
`;

const Title = styled.h1`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: #f7931a;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  z-index: 10;
  text-shadow: 0 2px 10px rgba(247, 147, 26, 0.3);
`;

const MobilePinDemo: React.FC = () => {
  return (
    <PageContainer>
      <Title>₿ Pin Art Canvas</Title>
      <MobilePinArt 
        enableHaptics={true}
        primaryColor="#f7931a"
        gridSpacing={8}
      />
    </PageContainer>
  );
};

export default MobilePinDemo;
